import React, { useState, useEffect, forwardRef, useRef } from "react";
import { Button } from '../../components/Wrappers'
import {
  TextField,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  Input,
  Chip,
  MenuItem
} from "@material-ui/core";

import enNZ from 'date-fns/locale/en-NZ'
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {
  CalendarToday as CalendarTodayIcon,
  HomeWork as HomeWorkIcon
} from '@material-ui/icons'

import { useUserState } from "../../context/UserContext";
import useStyles from './styles';
import config from '../../config';
import classnames from "classnames";

registerLocale('en-NZ', enNZ);

const MissingWork = forwardRef((props, ref) => {
  const classes = useStyles();
  const { regions } = useUserState();

  const monthRef = useRef(null);
  const monthCalendarRef = useRef(null);

  const [selectedMonth, setSelectedMonth] = useState(null);
  const [monthFocused, setMonthFocused] = useState(false);

  const [selectedRegion, setSelectedRegion] = useState(null);
  const [regionSelectionOpen, setRegionSelectionOpen] = useState(false);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  useEffect(() => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    setSelectedMonth(firstDayOfMonth);
  }, []);

  function formatDateYYYYMMDD(d) {
    if (!d) return null;
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  function onFocusMonth() {
    setMonthFocused(true);
  }

  function blurMonth() {
    setMonthFocused(false);
  }

  function handleSelectMonth(d) {
    if (!d) return;

    // force first day of selected month
    const firstDay = new Date(d.getFullYear(), d.getMonth(), 1);
    setSelectedMonth(firstDay);
    setMonthFocused(false);
  }

  function handleMonthKeyPress(event) {
    if (event.which === 9 || event.which === 13 || event.which === 27) {
      setMonthFocused(false);
    }
  }

  function onMouseDown(e) {
    e.stopPropagation();
  }

  function generateMissingWorkReport() {
    const monthStr = formatDateYYYYMMDD(selectedMonth);

    const regionId =
      selectedRegion && selectedRegion.id ? selectedRegion.id : null;

    const baseUrl = `${config.clientApi}/report/missing_work`;

    const params = [
      monthStr ? `month=${monthStr}` : null,
      regionId ? `region_id=${regionId}` : null
    ]
      .filter(Boolean)
      .join('&');

    const url = params ? `${baseUrl}?${params}` : baseUrl;

    console.log(url);
    window.open(url, '_blank');
  }

  return (
    <>
      <div className={classes.reportCalendars}>
        <TextField
          id="month"
          ref={monthRef}
          label="Month"
          className={classnames({
            'textField': true,
            'reportCalendarField': true,
            [classes.calendarFocused]: monthFocused
          })}
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <CalendarTodayIcon />
              </InputAdornment>
            ),
            inputComponent: () =>
              <DatePicker
                ref={monthCalendarRef}
                className={classes.textField}
                selected={selectedMonth}
                onChange={handleSelectMonth}
                onFocus={onFocusMonth}
                onClickOutside={blurMonth}
                onKeyDown={handleMonthKeyPress}
                locale="en-NZ"
                dateFormat="MMM yyyy"
                showMonthYearPicker
              />
          }}
        />
      </div>

      <FormControl
        variant="outlined"
        className={classnames(classes.regions, {
          'regions-control': true
        })}
      >
        <InputLabel id="missing-work-region-label">Region</InputLabel>

        <div className={classnames(classes.regionsInput, {
          'regions-control-input': true
        })}>
          <InputAdornment position="start">
            <HomeWorkIcon />
          </InputAdornment>

          <Select
            labelId="missing-work-region-label"
            id="missing-work-region"
            className={classes.regionsSelect}
            value={selectedRegion}
            onChange={(e) => {
              setSelectedRegion(e.target.value);
              setRegionSelectionOpen(false);
            }}
            open={regionSelectionOpen}
            onClose={() => setRegionSelectionOpen(false)}
            onOpen={() => setRegionSelectionOpen(true)}
            input={<Input id="missing-work-region-chip" />}
            renderValue={(selected) =>
              selected ? (
                <Chip
                  label={selected.name}
                  className={classes.chip}
                  variant="outlined"
                  onMouseDown={onMouseDown}
                />
              ) : null
            }
            MenuProps={MenuProps}
            size="small"
          >
            {regions && regions.map(region => (
              <MenuItem
                key={region.id}
                value={region}
                onClick={() => setRegionSelectionOpen(false)}
              >
                <span className="dropdown-avatar">{region.name}</span>
              </MenuItem>
            ))}
          </Select>
        </div>
      </FormControl>

      <div className={classes.layoutButtonsRow}>
        <Button
          onClick={generateMissingWorkReport}
          disabled={!selectedMonth || !selectedRegion}
        >
          <span>download</span>
        </Button>
      </div>
    </>
  );
});

export default MissingWork;
